import Registry from '../plugins/Registry';
import {preparePhone, prepareSite, makeid} from '../helpers/functions';


const DEFAULT_MARKER = {
  iconLayout: 'default#image',
  iconImageHref: ('/static/images/pin.png'),
  iconImageSize: [30, 40],
  iconImageOffset: [-15, -20],
  balloonPanelMaxMapArea: 0
};
const SELECTED_MARKER = {
  iconLayout: 'default#image',
  iconImageHref: ('/static/images/pin-black.png'),
  iconImageSize: [30, 40],
  iconImageOffset: [-15, -20],
  balloonPanelMaxMapArea: 0
};

export default class Map {
    constructor(obj) {
        this.obj = obj;
        this.id = obj.attr('id');
        this.ajaxUrl = obj.attr('map-data-url');
        this.ajaxData = obj.attr('map-data-d') ? JSON.parse(obj.attr('map-data-d')) : '';
        this.data = [];
        this.city = [0, 0];
        this.map = {};
        this.maxZoom = 15;
        this.baloonLayout = {};
        this.hintLayout = {};
        this.dataIDs = [];
        this.currentDealer = null;

        if (typeof this.id === 'undefined') {
            this.id = makeid(16);
            obj.attr('id', this.id);
        }

        this.render();

        Registry.set('yamap', this.id, this);
    }

    render() {
        this.ajax();
    }

    ajax() {

        const self = this;

        $.ajax({
            type: 'POST',
            url: self.ajaxUrl,
            async: false,
            data: {data: self.ajaxData},
            success: data => {
                self.data = data.dealers;

                if (data.city)
                    self.city = data.city;

                self.makeLayouts();
                self.showData();
            },
            error: data => {
                self.makeLayouts();
                self.showData();
            }
        });

    }

    makeLayouts() {

        this.makeMap();
        this.makeBalloonLayout();

    }

    getCenter() {
        return this.city;
    }

    static getZoom() {
        return 14;
    }

    makeMap() {
        const self = this;

        self.map = new ymaps.Map(self.id, {
            center: self.getCenter(),
            zoom: Map.getZoom(),
            controls: ["fullscreenControl", "zoomControl"]
        });

        self.map.behaviors.disable(['scrollZoom', 'multiTouch']);

        if ($(window).width() < 768)
            self.map.behaviors.disable(['drag']);
    }

    makeBalloonLayout() {
        const self = this;
        self.balloonLayout = ymaps.layout.storage.get('balloonLayout');
        self.hintLayout = ymaps.layout.storage.get('hintLayout');
        self.hintObjectLayout = ymaps.layout.storage.get('hintObjectLayout');
        self.balloonItemLayout = ymaps.layout.storage.get('balloonItemLayout');

        if (!self.balloonLayout || JSON.stringify(self.balloonLayout) === "{}") {
            self.balloonLayout = ymaps.templateLayoutFactory.createClass(
                `<div class="map-balloon">
                <p class="map-balloon__name">{{properties.name}}</p>
                <p class="map-balloon__name">Адрес:</p>
                <p>{{properties.address}}</p>
                <p class="map-balloon__name">Телефон:</p>
                <p><a href="tel:{{properties.truncated_phone}}" class="link">{{properties.phone}}</a></p>
                <div class="btn__map" popup="popup_test-drive75fl" popup-salon_id="{{properties.id}}" popup-action="test-drive">Записаться на тест-драйв</div>
                <div class="btn__map" popup="popup_on-stock_map" popup-salon_id="{{properties.id}}" popup-action="onStock" >Автомобили в наличии</div>
                <div class="btn__map" popup="popup_no-dealer" popup-salon_id="{{properties.id}}" popup-title="Получите выгодное предложение">Выгодное предложение</div>
                </div>`
            );
            ymaps.layout.storage.add('balloonLayout', self.balloonLayout);
        }

        if (!self.hintLayout || JSON.stringify(self.hintLayout) === "{}") {
            self.hintLayout = ymaps.templateLayoutFactory.createClass("<div class='map-balloon__hint'>" +
                "<b>{{ properties.name }}</b><br />" +
                "{{ properties.address }}" +
                "</div>", {
                    getShape: function () {
                        let firstChild,
                            el = this.getElement(),
                            result = null;
                        if (el) {
                            firstChild = el.firstChild;
                            result = new ymaps.shape.Rectangle(
                                new ymaps.geometry.pixel.Rectangle([
                                    [0, 0],
                                    [firstChild.offsetWidth, firstChild.offsetHeight]
                                ])
                            );
                        }
                        return result;
                    }
                }
            );
            ymaps.layout.storage.add('hintLayout', self.hintLayout);
        }

        if (!self.balloonItemLayout || JSON.stringify(self.balloonItemLayout) === "{}") {
            self.balloonItemLayout = ymaps.templateLayoutFactory.createClass(
                `<div class="title title__content"><h2>{{ properties.name }}</h2></div>
                <p><b>Адрес:</b></p>
                <p>{{ properties.address }}</p>
                <p><b>Телефон:</b></p>
                <p><a class="link link_decorated" href="tel:{{ properties.truncated_phone }}">{{ properties.phone }}</a></p>
                <p><b>Почта:</b></p>
                <p><a class="link link_bordered" href="mailto:{{ properties.email }}">{{ properties.email }}</a></p>`
            );

            ymaps.layout.storage.add('balloonItemLayout', self.balloonItemLayout);
        }


        if (!self.hintObjectLayout || JSON.stringify(self.hintObjectLayout) === "{}") {
            self.hintObjectLayout = ymaps.templateLayoutFactory.createClass(
                "{{ properties.hintContent|raw }}", {
                    getShape: function () {
                        let firstChild,
                            el = this.getElement(),
                            result = null;
                        if (el) {
                            firstChild = el.firstChild;
                            result = new ymaps.shape.Rectangle(
                                new ymaps.geometry.pixel.Rectangle([
                                    [0, 0],
                                    [firstChild.offsetWidth, firstChild.offsetHeight]
                                ])
                            );
                        }
                        return result;
                    }
                }
            );
            ymaps.layout.storage.add('hintObjectLayout', self.hintObjectLayout);
        }
    }

    showData() {
        const self = this;
        this.ObjectManager = new ymaps.ObjectManager({
            clusterize: false,
            gridByCoordinates: false,
            clusterDisableClickZoom: false,
            clusterBalloonItemContentLayout: this.balloonItemLayout,
            clusterIconLayout: 'default#pieChart',
            clusterHasHint: false,
            clusterHintContentLayout: this.hintObjectLayout,
        });

        this.collection = {
            "type": "FeatureCollection",
            "features": []
        };
        this.iterator = 0;

        if (this.data.length) {
            for (const point of this.data) {
                this.drawPoint(point);
            }
        }

        this.ObjectManager.objects.options.set(
            {
                balloonContentLayout: this.balloonLayout,
                hintLayout: this.hintLayout,
            }
        );

        this.ObjectManager.clusters.each(function () {
        });

        this.ObjectManager.events
            .add(['mouseenter'], function (e) {
                let cluster, objects;
                const objID = e.get('objectId');

                if (typeof objID === 'string') {
                    // Событие произошло на кластере, костыльно, но все же.
                    cluster = self.ObjectManager.clusters.getById(objID);
                    objects = cluster.properties.geoObjects;

                    self.setHint(cluster, objects);
                }
            });

        this.ObjectManager.add(this.collection);

        this.map.geoObjects.add(this.ObjectManager);

        if (this.data.length) {
            this.map.setBounds(this.ObjectManager.getBounds(), {
                checkZoomRange: true,
                zoomMargin: [25, 10, 30, 10]
            }).then(() => {
                if (self.map.getZoom() > self.maxZoom)
                    self.map.setZoom(self.maxZoom);
            });
        }

        document.querySelectorAll('.map-block__list .dealer').forEach(blockDealer => {
            blockDealer.addEventListener('click', () => {
                const attrId = Number(blockDealer.dataset.id);
                if (this.currentDealer) {
                  this.ObjectManager.objects.setObjectOptions(this.currentDealer, DEFAULT_MARKER);
                }
        
                this.currentDealer = this.currentDealer === attrId ? null : attrId;
        
                if (this.currentDealer) {
                  this.ObjectManager.objects.setObjectOptions(this.currentDealer, SELECTED_MARKER);
                }
            });
        });
    }

    calcCenter() {
        const self = this;
        this.map.setBounds(this.ObjectManager.getBounds(), {
            checkZoomRange: true,
            zoomMargin: [25, 10, 30, 10]
        }).then(() => {
            if (self.map.getZoom() > self.maxZoom)
                self.map.setZoom(self.maxZoom);
        });
    }

    drawPoint(point) {
        const placemark = {
            "type": "Feature",
            "id": point.id,
            "geometry": {
                "type": "Point",
                "coordinates": [point.lat, point.lng]
            },
            "options": {
                iconLayout: 'default#image',
                iconImageHref: ('/static/images/pin.png'),
                iconImageSize: [30, 40],
                iconImageOffset: [-15, -20],
                balloonPanelMaxMapArea: 0
            },
            "properties": {
                id: Number(point.id),
                name: point.name,
                address: point.address,
                site: point.site ? point.site : 'hidden',
                truncated_site: prepareSite(point.site),
                phone: point.phone,
                truncated_phone: preparePhone(point.phone),
                email: point.email,
                logo: point.logo,
                brand: point.brand,
                clusterCaption: point.name
            }
        };

        this.dataIDs = [...this.dataIDs, parseInt(point.id)];
        this.collection.features = [...this.collection.features, placemark];
    }

    setHint(cluster, objects) {
        cluster.properties.hintContent = objects.map(function (object) {
            return '<p class="map-balloon__hint-name">' + object.properties.name + '</p>';
        }).join('');

        this.ObjectManager.clusters.hint.setData(cluster);
    }

    findInData(key, value) {

        for (let i = 0; i < this.data.length; i++)
            if (this.data[i][key] === value)
                return this.data[i];

        return null;

    }


    filterByIDs(ids) {
        let _ids = ids;
        if (ids.length === 0)
            _ids = this.dataIDs;

        this.ObjectManager.setFilter((object) => _ids.indexOf(parseInt(object.properties.id)) !== -1);
        this.calcCenter();

    }
}